export const CONSOLE_HOSTNAME = "risk-console.africacodefoundry.com";

// The same build serves tenant sites and the staff console; the hostname picks which.
// Locally, set REACT_APP_CONSOLE=true to run the console on localhost.
export const isConsoleHost = () =>
  window.location.hostname === CONSOLE_HOSTNAME ||
  (["localhost", "127.0.0.1"].includes(window.location.hostname) && process.env.REACT_APP_CONSOLE === "true");
